// @ts-expect-error TS(7031) FIXME: Binding element 'dispatch' implicitly has an 'any'... Remove this comment to see the full error message
export default ({ dispatch }) =>
  // @ts-expect-error TS(7006) FIXME: Parameter 'next' implicitly has an 'any' type.
  (next) =>
  // @ts-expect-error TS(7006) FIXME: Parameter 'action' implicitly has an 'any' type.
  (action) => {
    next(action)
    switch (action.type) {
      case 'APP_INIT':
        dispatch({ type: 'INIT_MODALS' })
        dispatch({ type: 'INIT_USER' })
        dispatch({ type: 'INIT_PROFILES' })
        dispatch({ type: 'INIT_CHECK_BOOKMARKLET' })
        dispatch({ type: 'INIT_STRIPE_DETAILS' })
        dispatch({ type: 'INIT_ORGANIZATIONS' })
        break
      default:
        break
    }
  }
